import { useBackend } from "../../services";

export const useGetLatestPayment = () => {
  const { get } = useBackend();
  const getLatestPayment = async () => {
    return get("payments");
  };
  return { getLatestPayment };
};
